import script from "./ConsortiumWater.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsortiumWater.vue?vue&type=script&setup=true&lang=js"

import "./ConsortiumWater.vue?vue&type=style&index=0&id=09dc3e48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09dc3e48"]])

export default __exports__